import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  // Initialize currentRoleSubject in the constructor
  private currentRoleSubject: BehaviorSubject<string>;
  // Define the observable after the subject is initialized
  currentRole$: Observable<string>;
  
  constructor() {
    // Initialize with value from localStorage or default to 'general'
    const savedRole = localStorage.getItem('userRole');
    this.currentRoleSubject = new BehaviorSubject<string>(savedRole || 'general');
    this.currentRole$ = this.currentRoleSubject.asObservable();
  }

  // Call this method to update the current role (for example, after login)
  setRole(role: string): void {
    this.currentRoleSubject.next(role);
    localStorage.setItem('userRole', role);
  }

  // Get the current role
  getRole(): string {
    // Always check localStorage first to ensure consistency
    const savedRole = localStorage.getItem('userRole');
    if (savedRole && savedRole !== this.currentRoleSubject.value) {
      this.currentRoleSubject.next(savedRole);
    }
    return this.currentRoleSubject.value;
  }
}
